<template>
  <div class="merch">
    <BaseHero>
      <div class="hero-body">
        <h1 class="title">MERCH</h1>
        <h2 class="subtitle">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum magni
          aliquam <br />
          impedit eveniet rem molestiae architecto modi quisquam fugit nostrum?
        </h2>
      </div>
    </BaseHero>
  </div>
</template>

<script>
import BaseHero from "@/components/BaseHero";
export default {
  name: "Contact",
  components: { BaseHero },
};
</script>

<style lang="scss" scoped>
.merch {
  min-height: 100vh;
}
</style>
